import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bike-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bike-tag.component.html',
  styleUrls: ['./bike-tag.component.css', '../../common/scss/route-itinerary-common.scss'],
})
export class BikeTagComponent implements OnInit {
  @Input() count: number = 1;

  constructor() {}

  ngOnInit(): void {}
}
